import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';

import InputText from 'modules/_shared/components/InputText';

import { useEditShareModal } from '../context/EditShareModalContext';

const EditShareModalBody: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useEditShareModal();

  return (
    <Modal.Body>
      <div className="form-group">
        <InputText
          id="share-tag"
          label={t('Tag')}
          value={data.tag}
          onChange={actions.handleChangeTag}
          lgSize
        />
      </div>
    </Modal.Body>
  );
};

export default EditShareModalBody;
